module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-table-simple', {
    staticClass: "table-v2",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', {
    staticStyle: {
      "font-size": "7pt !important"
    }
  }, [_vm._v(_vm._s(_vm.formData.point_type == "ghe" ? "GHE (SETOR)" : "FUNÇÃO"))]), _vm._v(" "), _c('b-th', [_c('table', {
    attrs: {
      "width": "100%",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "7pt !important",
      "border": "none",
      "background": "transparent",
      "color": "#fff"
    },
    attrs: {
      "width": "80%"
    }
  }, [_vm._v("\n                AGENTE AVALIADO\n              ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "7pt !important",
      "border": "none",
      "background": "transparent",
      "color": "#fff"
    },
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("\n                METODOLOGIA\n              ")])])])])], 1)], 1), _vm._v(" "), _c('b-tbody', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTable),
      expression: "loadingTable"
    }]
  }, _vm._l((_vm.tableData), function(data, i) {
    return _c('b-tr', {
      key: i
    }, [_c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, _vm._l((data.points), function(point, j) {
      return _c('p', {
        key: i + j
      }, [_c('el-checkbox', {
        attrs: {
          "label": point.id,
          "disabled": _vm.tableMedicaoChecked.length > 0 || data.points.length > 1,
          "title": data.points.length > 1 ?
            'Não é possível agrupar um GHE que já foi agrupado anteriormente' :
            ''
        },
        model: {
          value: (_vm.tablePointChecked),
          callback: function($$v) {
            _vm.tablePointChecked = $$v
          },
          expression: "tablePointChecked"
        }
      }), _vm._v(" "), (_vm.formData.point_type == 'ghe') ? _c('span', [_vm._v("\n              " + _vm._s(point.ghe) + " (" + _vm._s(point.descricao) + ")\n            ")]) : (_vm.formData.point_type == 'funcao') ? _c('span', [_vm._v("\n              " + _vm._s(point.nome) + "\n            ")]) : _vm._e()], 1)
    }), 0), _vm._v(" "), _c('b-td', {
      style: ('background:' + (i % 2 == 0 ? '#E6E6E6' : ''))
    }, _vm._l((data.orcamento_medicoes), function(orcamento_medicao, j) {
      return _c('table', {
        key: j,
        attrs: {
          "width": "100%"
        }
      }, [_c('tr', [_c('td', {
        staticStyle: {
          "font-size": "7pt !important",
          "background": "#f9f6db"
        },
        attrs: {
          "width": "80%"
        }
      }, [(false) ? _c('el-checkbox', {
        attrs: {
          "label": orcamento_medicao.id,
          "disabled": _vm.tablePointChecked.length > 0
        },
        model: {
          value: (_vm.tableMedicaoChecked),
          callback: function($$v) {
            _vm.tableMedicaoChecked = $$v
          },
          expression: "tableMedicaoChecked"
        }
      }) : _vm._e(), _vm._v(" "), _c('b', [_vm._v("\n                  " + _vm._s(orcamento_medicao.fator_risco.nome) + "\n                ")])], 1), _vm._v(" "), _c('td', {
        staticStyle: {
          "font-size": "7pt !important",
          "background": "#f9f6db"
        },
        attrs: {
          "width": "20%"
        }
      }, [_c('b', [_vm._v(_vm._s(orcamento_medicao.fator_risco.cod_metodologia))])])]), _vm._v(" "), _c('tr', [_c('td', {
        staticStyle: {
          "font-size": "7pt !important",
          "border": "none"
        },
        attrs: {
          "colspan": "2"
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-4"
      }, [_vm._v("\n                    Nº DE AMOSTRAGENS\n                    "), _c('el-input', {
        attrs: {
          "type": "number"
        },
        on: {
          "change": function($event) {
            return _vm.formataDados()
          }
        },
        model: {
          value: (orcamento_medicao.amostragem),
          callback: function($$v) {
            _vm.$set(orcamento_medicao, "amostragem", $$v)
          },
          expression: "orcamento_medicao.amostragem"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-md-4"
      }, [_vm._v("\n                    VALOR UNITÁRIO\n                    "), _c('el-input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('money'),
          expression: "'money'"
        }],
        attrs: {
          "type": "text"
        },
        on: {
          "change": function($event) {
            return _vm.formataDados()
          }
        },
        model: {
          value: (orcamento_medicao.valor_venda),
          callback: function($$v) {
            _vm.$set(orcamento_medicao, "valor_venda", $$v)
          },
          expression: "orcamento_medicao.valor_venda"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-md-4"
      }, [_vm._v("\n                    VALOR TOTAL\n                    "), _c('el-input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('money'),
          expression: "'money'"
        }],
        attrs: {
          "type": "text",
          "readonly": ""
        },
        model: {
          value: (orcamento_medicao.valor_total),
          callback: function($$v) {
            _vm.$set(orcamento_medicao, "valor_total", $$v)
          },
          expression: "orcamento_medicao.valor_total"
        }
      })], 1)])])])])
    }), 0)], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-save",
      "type": "success",
      "value": "Salvar Medições"
    },
    on: {
      "click": _vm.salvar
    }
  }), _vm._v(" "), _c('ed-button', {
    attrs: {
      "icon": "fa fa-history",
      "type": "primary",
      "title": "Clique aqui para restaurar e inicializar o orçamento",
      "value": "Restaurar Medições"
    },
    on: {
      "click": _vm.restaurar
    }
  }), _vm._v(" "), (_vm.tablePointChecked.length > 1) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-object-group",
      "type": "warning",
      "title": "Clique aqui para agrupar as medições selecionadas",
      "value": 'Agrupar ' + this.formData.point_type.toUpperCase()
    },
    on: {
      "click": _vm.agrupar
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aa41fb5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/orcamento/medicao.vue
// module id = 1484
// module chunks = 45